import { render, staticRenderFns } from "./CourseMag.vue?vue&type=template&id=7db4c340&scoped=true&"
import script from "./CourseMag.vue?vue&type=script&lang=js&"
export * from "./CourseMag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db4c340",
  null
  
)

export default component.exports